/**
 * @param {number} length
 * @return {Array}
 */
export default (function (length) {
  return Array.apply(null, { length: length });
});


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/range.js
// module id = HHnW
// module chunks = 1